import React from 'react';
import { Card } from './ui/card';
import { Skeleton } from './ui/skeleton';

export const DecisionCardSkeleton = () => {
  return (
    <Card className="p-4" data-testid="decision-card-skeleton">
      <div className="space-y-3">
        {/* Header */}
        <div className="flex items-center justify-between">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-16" />
        </div>
        
        {/* Title */}
        <Skeleton className="h-5 w-3/4" />
        
        {/* Badges */}
        <div className="flex gap-2">
          <Skeleton className="h-5 w-16" />
          <Skeleton className="h-5 w-16" />
        </div>
        
        {/* Content */}
        <Skeleton className="h-12 w-full" />
        
        {/* Analysis */}
        <Skeleton className="h-8 w-full" />
        
        {/* Footer */}
        <div className="flex items-center justify-between pt-2">
          <div className="flex gap-2">
            <Skeleton className="h-6 w-20" />
            <Skeleton className="h-6 w-20" />
          </div>
          <Skeleton className="h-8 w-24" />
        </div>
      </div>
    </Card>
  );
};

export const DashboardSkeleton = () => {
  return (
    <div className="grid lg:grid-cols-3 gap-4">
      {/* Build Next Lane */}
      <div className="space-y-3">
        <div className="flex items-center gap-2 mb-3">
          <Skeleton className="h-6 w-32" />
          <Skeleton className="h-5 w-8 rounded-full" />
        </div>
        <DecisionCardSkeleton />
        <DecisionCardSkeleton />
      </div>
      
      {/* Fix Now Lane */}
      <div className="space-y-3">
        <div className="flex items-center gap-2 mb-3">
          <Skeleton className="h-6 w-24" />
          <Skeleton className="h-5 w-8 rounded-full" />
        </div>
        <DecisionCardSkeleton />
        <DecisionCardSkeleton />
      </div>
      
      {/* Ignore Lane */}
      <div className="space-y-3">
        <div className="flex items-center gap-2 mb-3">
          <Skeleton className="h-6 w-20" />
          <Skeleton className="h-5 w-8 rounded-full" />
        </div>
        <DecisionCardSkeleton />
      </div>
    </div>
  );
};

export const ImportLoadingSkeleton = () => {
  return (
    <Card className="p-6 max-w-2xl mx-auto" data-testid="import-loading-skeleton">
      <div className="space-y-4">
        <Skeleton className="h-6 w-48 mx-auto" />
        <Skeleton className="h-4 w-64 mx-auto" />
        <div className="pt-4 space-y-3">
          <Skeleton className="h-2 w-full" />
          <Skeleton className="h-2 w-3/4" />
          <Skeleton className="h-2 w-5/6" />
        </div>
      </div>
    </Card>
  );
};
